import type { RestaurantAsset } from '../types';

const now = Date.now();
const d = 86400000;

export const initialAssets: RestaurantAsset[] = [
  {
    id: 'AST-1',
    kind: 'quantity',
    name: 'Chafing dishes',
    category: 'kitchen_equipment',
    location: 'kitchen',
    quantity: 8,
    replaceBelow: 6,
    unitCost: 45,
    unitCostCurrency: 'NZD',
    supplier: 'Bidfood',
    condition: 'used',
    status: 'in_use',
    createdAt: now - d * 40,
    updatedAt: now - d * 2,
  },
  {
    id: 'AST-2',
    kind: 'quantity',
    name: 'Dinner plates',
    category: 'tableware',
    location: 'dining',
    quantity: 180,
    replaceBelow: 150,
    unitCost: 4.5,
    unitCostCurrency: 'NZD',
    condition: 'used',
    status: 'in_use',
    createdAt: now - d * 90,
    updatedAt: now - d * 1,
  },
  {
    id: 'AST-3',
    kind: 'quantity',
    name: 'Chef jackets',
    category: 'uniforms',
    location: 'storage',
    quantity: 12,
    replaceBelow: 8,
    condition: 'used',
    status: 'in_use',
    createdAt: now - d * 20,
    updatedAt: now - d * 5,
  },
  {
    id: 'AST-4',
    kind: 'tagged',
    name: 'Gas burner (front left)',
    category: 'kitchen_equipment',
    location: 'kitchen',
    quantity: 1,
    assetTag: 'KIT-BURN-01',
    serialNumber: 'GB-44821',
    purchaseDate: now - d * 200,
    unitCost: 220,
    unitCostCurrency: 'NZD',
    condition: 'new',
    status: 'in_use',
    createdAt: now - d * 200,
    updatedAt: now - d * 10,
  },
];
